<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header card-header-rose card-header-icon">
        <div class="card-icon">
          <i class="material-icons">assignment</i>
        </div>
        <h4 class="card-title">Création d'un JobAlert</h4>
      </div>
      <div class="card-body" id="wizardProfile">
        <form action="" [formGroup]="controlForm">
          <div class="row">
            <div class="col-md-12">
              <mat-form-field [color]="param.color" [ngClass]="">
                <input type="text"
                       name="firstname"
                       matInput
                       id="text"
                       placeholder="* Nom"
                       maxlength="50"
                       formControlName="nom">
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field [color]="param.color" [ngClass]="">
                <input type="email"
                       name="email"
                       matInput
                       placeholder="* Adresse email"
                       formControlName="email"
                       (input)="optionnal()">
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field [color]="param.color" [ngClass]="">
                <input type="email"
                       name="jobalert_portable"
                       matInput
                       placeholder="* Numéro de mobile (sms gratuit)"
                       formControlName="jobalert_portable"
                       (input)="optionnal()">
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field [color]="param.color" appearance="legacy">
                <mat-label>Fonctions</mat-label>
                <mat-select panelClass="example-panel-{{param.color}}" formControlName="fonctionName" name="fonction" multiple>
                  <mat-option *ngFor="let fonction of emploiFonction" [value]="fonction">{{fonction.fonction}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field [color]="param.color" appearance="legacy">
                <mat-label>Régions</mat-label>
                <mat-select panelClass="example-panel-{{param.color}}" formControlName="regionName" name="region" multiple>
                  <mat-option *ngFor="let regions of region" [value]="regions">{{regions.region}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="card-footer">
          <button mat-raised-button type="button" (click)="onNoClick()" class="btn btn-fill btn-rose">Annuler</button>
          <button mat-raised-button [disabled]="controlForm.invalid" type="button" (click)="onSubmit()" class="btn btn-fill btn-rose">Valider</button>

        </div>
      </div>
    </div>
  </div>
</div>
